import axios from 'axios';

import { getApiUrl } from '../utils/baseUrl';

export const queryPaymentMethodHash = async (propertyId: number, bearerToken: string, paymentMethodId: string) => {
  try {
    const baseUrl = getApiUrl();
    const apiEndpoint = '/payments/payment-methods/v1.0/hash';

    const { data: response } = await axios.post(`${baseUrl}${apiEndpoint}`, {
      type: 'stripe_payment_method',
      stripe_payment_method: {
        token: paymentMethodId,
      },
    }, {
      headers: {
        'X-Property-Id': propertyId,
        'Content-Type': 'application/json',
        Authorization: `Bearer ${bearerToken}`,
      },
    });
    return (response.success) ? response : { error: response.statusMessage || 'Unknown error.' };
  } catch (err) {
    return { error: (err as any).message || 'Unknown network error.' };
  }
};
